module.exports = new __parcel__URL__("insight-object-view-attributes-skeleton.tpl.2ad800bb.svg").toString();